import React, { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function TextEffectSplite() {
  const component = useRef();

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      const spans = component.current.querySelectorAll("h1");

      gsap.from(spans, {
        opacity: 0,
        y: 100,
        ease: "back.out(1.7)",
        duration: 1,
        stagger: 0.1,
        scrollTrigger: {
          trigger: component.current,
          start: "top 80%",
          end: "bottom 60%",
          toggleActions: "play none none reverse",
        },
      });
    }, component);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={component}>
      <div className="h-screen w-screen flex justify-center items-center">
        {"GSAP SplitText + React = 💚".split("").map((char, index) => (
          <h1
            key={index}
            className="justify-center typing-text mt-4 text-5xl tracking-tight text-gray-900"
            style={{ display: "inline-block" }}
          >
            {char}
          </h1>
        ))}
      </div>
    </div>
  );
}
